import React from 'react';
import { useTranslation } from 'react-i18next';
import H2 from '../../components/Titles/h2';
import Hr from '../../components/Style/hr';
import Button from '../../components/Buttons/button';
import Link from '../../components/Links/link';

export default function StepConfirmationCart({ returnedData }) {
    const { t } = useTranslation();

    const handleBackToShop = () => {
        // si tu veux retourner à la boutique depuis le composant parent :
        returnedData && returnedData('check'); // ou 'goToHome' si tu gères ça dans Cart
    };

    return (
        <div className="bg-white shadow p-6 md:p-8 flex flex-col gap-6">
            <div>
                <H2
                    title={t('cart.confirmation.title') || "Merci pour votre commande !"}
                    theme="main"
                    fontWeight="semibold"
                />
                <Hr />
                <p className="text-sm md:text-base text-description opacity-70 mt-3">
                    {t('cart.confirmation.subtitle') ||
                        "Votre paiement a bien été validé. Un e-mail de confirmation vient de vous être envoyé."}
                </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center m-auto">
                <Link
                    link="/"
                    children={
                        <Button
                            text={t('cart.confirmation.backToHome') || "Retour à l'accueil"}
                            onClick={handleBackToShop}
                        />
                    }
                />
            </div>
        </div>
    );
}